import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { Breadcrumb, BreadcrumbsContext } from '../BreadcrumbsContext';

export const BreadcrumbsProvider: FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

  const context = useMemo(
    () => ({ breadcrumbs, setBreadcrumbs }),
    [breadcrumbs],
  );
  return (
    <BreadcrumbsContext.Provider value={context}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
